// Copyright (c) Mysten Labs, Inc.
// SPDX-License-Identifier: Apache-2.0

// Friendly labels for well-known reserved/system addresses. System transactions
// (consensus prologue, settlement, etc.) are sent from the zero address; the
// framework/system objects live at the low reserved addresses.

export interface KnownAccount {
	label: string;
}

function pad(address: string): string {
	const hex = address.toLowerCase().replace(/^0x/, '');
	return `0x${hex.padStart(64, '0')}`;
}

const KNOWN: Record<string, KnownAccount> = {
	[pad('0x0')]: { label: 'Safe System account' },
	[pad('0x1')]: { label: 'Move stdlib' },
	[pad('0x2')]: { label: 'Safe Framework' },
	[pad('0x3')]: { label: 'Safe System' },
	[pad('0x5')]: { label: 'Safe System State' },
	[pad('0x6')]: { label: 'Clock' },
};

export function getKnownAccount(address: string | null | undefined): KnownAccount | null {
	if (!address) return null;
	return KNOWN[pad(address)] ?? null;
}
